import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';

import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { NetezzaCopySource } from 'app/model/pipeline/copysource/netezza.copysource';
import { ValueAdapter } from '../../value.adapter';
import { partitionOptionConst } from 'app/registries/consts/metadata-consts';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(NetezzaCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        partitionOption: '*',
        partitionSettings: {
            partitionColumnName: '*',
            partitionUpperBound: '*',
            partitionLowerBound: '*'
        }
    }
})
export class NetezzaCopySourceAdapter extends CopySourceAdapter<NetezzaCopySource, Model.NetezzaSource> {
    protected override async _toResource(copySource: NetezzaCopySource): Promise<Model.NetezzaSource> {
        const result = this._toTabularResource(copySource, Metamodel.modelFor(NetezzaCopySource).name);

        result.partitionOption = ValueAdapter.toResource(copySource, NetezzaCopySource.PARTITION_OPTION);
        if (copySource.partitionOption === partitionOptionConst.dyamicRange) {
            result.partitionSettings = {
                partitionColumnName: ValueAdapter.toResource(copySource, NetezzaCopySource.PARTITION_COLUMN_NAME),
                partitionUpperBound: ValueAdapter.toResource(copySource, NetezzaCopySource.PARTITION_UPPER_BOUND),
                partitionLowerBound: ValueAdapter.toResource(copySource, NetezzaCopySource.PARTITION_LOWER_BOUND)
            };
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.NetezzaSource,
        copyActivity: CopyActivity
    ): Promise<NetezzaCopySource> {
        const result = this._toTabularModel(resource, copyActivity, NetezzaCopySource.MODEL) as NetezzaCopySource;

        if (resource.partitionOption != null) {
            ValueAdapter.toModel(result, NetezzaCopySource.PARTITION_OPTION, resource.partitionOption);
        } else {
            // for existing netezza source without partitionOption, keep its partitionOption as none instead of default value: dataSlice
            result.partitionOption = partitionOptionConst.none;
        }
        if (resource.partitionSettings != null) {
            ValueAdapter.toModel(
                result,
                NetezzaCopySource.PARTITION_COLUMN_NAME,
                resource.partitionSettings.partitionColumnName
            );
            ValueAdapter.toModel(
                result,
                NetezzaCopySource.PARTITION_LOWER_BOUND,
                resource.partitionSettings.partitionLowerBound
            );
            ValueAdapter.toModel(
                result,
                NetezzaCopySource.PARTITION_UPPER_BOUND,
                resource.partitionSettings.partitionUpperBound
            );
        }
        return result;
    }
}
